import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { SharedDataService } from './services/shared-data.service';
import { FormBuilder } from '@angular/forms';
import { SideMenuService } from './componens/sidemenu/sidemenu.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mobiwise_n';
  isSidebar: boolean = false;
  routePath: any;
  apicallcomplete: boolean = true;
  isPermission: boolean = true;
  displayedContent: string = 'dashboard';
  panelOpenState = false;
  headerDisplay:boolean=true;
  mobileHeader: boolean = false;
  @ViewChild('sidenav') public sidenav!: MatSidenav;
  applyP0Class: boolean=true;
  isLanding:boolean = false;
  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private _formBuilder: FormBuilder,
    private smService: SideMenuService
  ) {
    localStorage.setItem('CUSTOMER', 'null');
    localStorage.setItem('MENU', 'true')
    this.headerDisplay = false;
  }
  
  options = this._formBuilder.group({
    bottom: 0,
    fixed: false,
    top: 0,
  });

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);

  isSidebarOpen(_event: boolean) {
    this.isSidebar = _event;
  }

  ngAfterViewInit(): void {
    this.smService.setSidenav(this.sidenav);
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.applyP0Class = !event.urlAfterRedirects.includes('/um');
        if (event.urlAfterRedirects != '/' && (event.urlAfterRedirects.includes('/mobile') || event.urlAfterRedirects.includes('/web'))) {
          this.headerDisplay = false;
        } else {
          this.headerDisplay = false;
          this.mobileHeader = false;
        }

        if(event.urlAfterRedirects.includes('/splash') || event.urlAfterRedirects.includes('/signUp') ){
          document.body.classList.add('lp-main-container');
          this.isLanding = true;
        }else if(event.urlAfterRedirects.includes('/privacy-policy')){
          document.body.classList.add('pp-main-container');
          this.isLanding = true;
        }
        else{
          document.body.classList.remove('lp-main-container');
          if(document.body.classList.contains('pp-main-container')){
            document.body.classList.remove('pp-main-container');
          }
          this.isLanding = false
        }
      }
    });
  }

  /**
   * Sidebar Toggle value change
   * @param _event boolean value to check whether the sidebar is open/close
   */
  sidebarAction(_event: boolean) {
    this.isSidebar = _event;
  }

  closeSideNav(event:any){
    this.isSidebar = false;
  }

  showContent(content: string) {
    this.displayedContent = content;
    this.sharedDataService.updateContent(content);
  }

  toggleSidebar() {
    this.sidenav.toggle();
  }
}
